import * as React from "react";
import {
  PostingForm as SharedPostingForm,
  type PostingFormProps as SharedProps,
} from "@chotca/posting-form";
import { AddressPicker } from "@/components/address-picker";

export type {
  PostingFormOutput,
  PostingFormTemplate,
} from "@chotca/posting-form";

// Admin flavor: no chevron-back header, 5-step layout (Advanced on own step),
// secondary buttons on both mobile + desktop.
type AdminProps = Omit<
  SharedProps,
  | "AddressPicker"
  | "onMobileBack"
  | "splitAdvancedStep"
  | "mobileActionVariant"
  | "desktopSubmitVariant"
>;

export function PostingForm(props: AdminProps) {
  return (
    <SharedPostingForm
      {...props}
      AddressPicker={AddressPicker}
      splitAdvancedStep
      mobileActionVariant="secondary"
      desktopSubmitVariant="secondary"
    />
  );
}
